import { MoldOrder } from "../types/mold";
import { calculateFormProgress, getValidationMessagesFromProgress } from "../utils/formProgress";
import { UserProfile } from '../types/user';
import { LoadedFormConfig } from '../components/Questionnaire/formConfigLoader';


/**
 * Gets validation issues for a mold order form submission
 * @param moldOrder The mold order to validate
 * @param loadedFormConfig The loaded form config (with images)
 * @param currentFiles Array of current file objects (must have .tag or .tags property)
 * @returns Array of validation issue messages
 */
export const getValidationIssues = (
  moldOrder: MoldOrder,
  loadedFormConfig: LoadedFormConfig,
  currentFiles: Array<{ tag?: string; tags?: string[] }>
): string[] => {
  // Delegate message construction to centralized helper to avoid duplicated logic
  const progress = calculateFormProgress(
    moldOrder.orderDetail?.form || {},
    loadedFormConfig.sections,
    moldOrder
  );

  const messages = getValidationMessagesFromProgress(progress, loadedFormConfig as any, currentFiles, moldOrder);
  return messages;
};

export const validateIfUserHasPermission = (user: UserProfile | null, moldOrder: MoldOrder): boolean => {
  if (user === null) {
    return false;
  }
  return user.user_id === moldOrder.assignedTo.id || user.role === 'ADMIN';
}
